/*
 * @Author: yanyongchao
 * @Date: 2018-12-30 23:41:55
 */
import Vue from 'vue'
import axios from 'axios'
import { getBody, getParam } from 'untils/http-header'
import { $toast } from 'untils/global'
import store from 'store'
import getAccessToken from '@/untils/getAccessToken'

const axiosX = axios.create({
  baseURL: '/rest',
  timeout: 80000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

axiosX.interceptors.request.use(
  async function(config) {
    let accessToken = (store.getters.accessToken && store.getters.accessToken.length) ? store.getters.accessToken : localStorage.getItem('access_token')
    if (!accessToken) {
      accessToken = await getAccessToken()
    }
    config.headers['access-token'] = accessToken
    return config
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

axiosX.interceptors.response.use(
  function(response) {
    return checkCode(response)
  },
  function(err) {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '错误请求'
          break
        case 401:
          err.message = '未授权，请重新登录'
          break
        case 403:
          err.message = '拒绝访问'
          break
        case 404:
          err.message = '请求错误,未找到该资源'
          break
        case 405:
          err.message = '请求方法未允许'
          break
        case 408:
          err.message = '请求超时'
          break
        case 500:
          err.message = '服务器端出错'
          break
        case 501:
          err.message = '网络未实现'
          break
        case 502:
          err.message = '网络错误'
          break
        case 503:
          err.message = '服务不可用'
          break
        case 504:
          err.message = '网络超时'
          break
        case 505:
          err.message = 'http版本不支持该请求'
          break
        default:
          err.message = `连接错误${err.response.status}`
      }
    } else {
      err.message = '登录超时，请重新登录'
    }
    // 状态码异常提示
    statusErrorHandle(err.message)
    return Promise.reject(err)
  }
)

/**
 * 判断请求是否成功，如果失败则给出对应提示
 * @param response 请求数据
 */
function checkCode(response) {
  // 获取市区数据不需要显示错误信息
  let url = response.request.responseURL
  if (url && !!~url.indexOf('/app/public/get-pa-area')) {
    return response.data
  }

  // 如果http状态码正常，则直接返回数据
  if (response && response.data.success) {
    return response.data
  }
  // code异常提示
  codeErrorHandle(response)
  return response.data
}

/**
 * 当请求出现问题时候做的处理，把错误请求信息展示
 * @param res 返回的信息
 */
function statusErrorHandle(errorMessage) {
  $toast({ message: errorMessage })
}

/**
 * 当请求成功，但是出现了业务层面错误时候，给出对应的错误处理
 * @param res 返回的信息
 */
function codeErrorHandle(res) {
  console.log('接口报错1：', res)
  const data = res.data
  const expireCode = [400, 401, 402] // 登录失效的code
  if (expireCode.includes(data.code)) {
    // 登录过期调原生方法
    let expireData = {
      code: data.code,
      message: data.message
    }
    Vue.prototype.$jfs.toReStartLogin(expireData)
    // $toast({ message: data.message }).then(() => {
    // })
  } else {
    $toast({ message: data.message })
  }
}

const XHR = ({
  method = 'post',
  qs = true,
  loading = false,
  loginRequire = true,
  reqComplex = false,
  reqContentType = 'urlencoded'
}) => {
  // 带请求进度条成功方法
  const sucFunX = res => {
    return res
  }

  // 成功执行方法
  const sucFunC = res => {
    return res
  }

  // 带请求进度条失败方法
  const errFunX = err => {
    return Promise.reject(err)
  }
  // 失败执行访求
  const errFunC = err => {
    return Promise.reject(err)
  }

  // 判断是否需要Longing
  const sucFun = loading ? sucFunX : sucFunC

  // 判断是否需要Longing
  const errFun = loading ? errFunX : errFunC

  return { sucFun, errFun }
}

// 简单带请求带状态POST
// Posting('/fsddf', {id: 111, page: 1})
const Posting = function(url, data) {
  let { sucFun, errFun } = XHR({ loading: true })
  return axiosX
    .post(url, getBody(data))
    .then(sucFun)
    .catch(errFun)
}

// 简单带请求POST
// Post('/fsddf', {id: 111, page: 1})
const Post = function(url, data) {
  let { sucFun, errFun } = XHR({ loading: false })
  return axiosX
    .post(url, getBody(data))
    .then(sucFun)
    .catch(errFun)
}

// 简单带请求带状态Get
// Geting('/fsddf', {id: 111, page: 1})
const Geting = function(url = '', data) {
  let { sucFun, errFun } = XHR({ loading: true })
  return axiosX
    .get(url, { params: getParam(data) })
    .then(sucFun)
    .catch(errFun)
}

// 简单带请求GET
// Get('/fsddf', {id: 111, page: 1})
const Get = function(url = '', data) {
  let { sucFun, errFun } = XHR({ loading: false })
  return axiosX
    .get(url, { params: getParam(data) })
    .then(sucFun)
    .catch(errFun)
}

export { axios, Posting, Geting, Post, Get }
